// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { ICertificatePaymentParams, ICertificatePaymentResponse, IPendingCertificateResponse, IPreviewCertificate } from 'app_types/user/certificateTypes'
// @end


interface ILoadPreviewOptions {
  format: number,
  template: number,
  certificate_queue?: string
  updateCertificate?: boolean
}
class CertificateService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async loadPreview(hash: string, options: ILoadPreviewOptions = { format: 2, template: 1 }) {
    this.refreshAuthToken()

    let responseData: IPreviewCertificate

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate/preview`,
      auth_token: this.token,
      params: {
        hash,
        ...options
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  public certificateGeneratedByMonth = async (params?: { months?: number }) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificatequeue/fetch-certificate-generated-by-month`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }
  }

  async reGenerateCertification(params: {userId?: string, courseId?: string, certificateQueueId?: string, isMultiple?: boolean}) {
    this.refreshAuthToken()

    let responseData: IPreviewCertificate

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate/re-generate-certification`,
      auth_token: this.token,
      params: {
        ...params
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  updateCertificationFirstDownloadDate = async (data: any) => {
    this.refreshAuthToken()
    console.log("data");
    console.log(data);
    data.id = data._id;
    let responseData: IPreviewCertificate
    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificateQueue/update/${data.id}`,
      auth_token: this.token,
      params: { ...data },
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  checkPendingCertificationsWithPayment = async () => {
    this.refreshAuthToken()
    let responseData: IPendingCertificateResponse
    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificatequeue/check-pending-certifications-with-payment`,
      auth_token: this.token,
      params: {},
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData;
    }

    return null
  }

  changeUserNotified = async (certificateQueueId: string, userNotified = true) => {
    this.refreshAuthToken()
    let responseData: IPendingCertificateResponse
    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificatequeue/update/${certificateQueueId}`,
      auth_token: this.token,
      params: { userNotified },
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  certificatePayment = async ({ certificateQueueId, currencyType, certificateInfo }: ICertificatePaymentParams) => {
    this.refreshAuthToken()
    let responseData: ICertificatePaymentResponse
    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: '/api/admin/certificatequeue/certificate-payment',
      auth_token: this.token,
      params: { certificateQueueId, currencyType, certificateInfo },
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

}

export default CertificateService
